import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_azgyao0cia: FaireBrandEntity = {
  token: "b_azgyao0cia",
  type: "brand",
  name: "WORTH IMPORTS",
  avatarUrl:
    "https://cdn.faire.com/fastly/4cb0de831262ca4f6ed869bc468627210c8156c87c1d90b507aa093d6dddeca2.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/cea48fe1ca9c0e8aa5457d851fd99dfae445e1bceb02912b17f3514f8c20867a.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/4cb0de831262ca4f6ed869bc468627210c8156c87c1d90b507aa093d6dddeca2.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/cea48fe1ca9c0e8aa5457d851fd99dfae445e1bceb02912b17f3514f8c20867a.jpeg",
  location: "Ashland, MA, USA",
  minimumOrderDollars: 100,
  rating: 4.4,
  reviewCount: 121,
  isInsider: true,
  description:
    "Worth Imports is a designer, importer and distributor of Christmas, Halloween, Fall and Spring decorations. We sell strictly wholesale. Worth Imports features artificial floral, natural cones and pods, planters, scarecrows, Halloween and Christmas decorations for both inside and outside. Our selection includes country and primitive decor as well as classic looks and upscale glitter. We have been in business since 1994 and strive to offer you the best designs at prices that sell.",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:20.715Z",
    importedBy: "entity-db-cli",
  },
};
